export const aiTokens = {
  accent: '#6366F1',
  accentHover: '#4F46E5',
  accentSoft: 'rgba(99,102,241,0.10)',
  accentBorder: 'rgba(99,102,241,0.30)',
  gradient: 'linear-gradient(90deg, #6366F1 0%, #8B5CF6 50%, #EC4899 100%)',
  errorBg: 'rgba(194,66,66,0.05)',
  errorBorder: 'rgba(194,66,66,0.3)',
} as const;

export const sparkleKeyframes = {
  '@keyframes sparkle': {
    '0%, 100%': { opacity: 0.4, transform: 'scale(1)' },
    '50%': { opacity: 1, transform: 'scale(1.15)' },
  },
} as const;
